import React from 'react';
import CircleIcon from '@mui/icons-material/Circle';

interface LedProps {
    value: boolean;
}

const Led: React.FunctionComponent<LedProps> = (props) => {
    const { value } = props;

    if (value) {
        return <CircleIcon fontSize="small" color="success" />;
    }
    return <CircleIcon fontSize="small" color="warning" />;
};

export default Led;
